import React from 'react'
import PropTypes from 'prop-types'
// import { Platform, View, TouchableHighlight } from 'react-native'
import { Text, Icon,LoadingIcon } from '../../Components'
import { Colors } from '../../global'
// import LinearGradient from 'react-native-linear-gradient'
// import Spinner from 'react-native-spinkit'
import _ from 'lodash'
import { Button } from 'antd'

const styles = {
  container: {
    display:'flex',
    flexDirection:'row',
    padding: 0,
    paddingTop: 0,
    paddingBottom: 0,
    width: '100%',
    height: 44,
    maxHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
  both:{
    display:'flex',
    flex: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  text: {
    paddingHorizontal: 0,
  },
  disabled: {
    opacity: 0.2,
  },
}



const ButtonComponent = ({ text, icon, disabled, style, variant, rounded, isLoading, both, ...rest }) => {
  ///LIGHT AND DARK THEME IMPLEMENTATION styles that contain color information must be defined within component(Not in predefined styles object)
  if(Array.isArray(style)) style = Object.assign({}, ...style)
  if(disabled) style = {...style,...styles.disabled}
  const getVariant = (variant) => {
    switch (variant) {
      case 'custom': 
        return {}
      case 'white':
        return {
          backgroundColor: Colors.white,
          color: Colors.black,
        }
      case 'white-outline':
        return {
          color: Colors.white,
          borderWidth: 1,
          borderColor: Colors.white,
          backgroundColor: Colors.transparent,
        }
      case 'black-outline':
        return {
          color: Colors.black,
          borderWidth: 1,
          borderColor: Colors.black,
          backgroundColor: Colors.transparent,
        }
      case 'primary':
        return {
          backgroundColor: Colors.primary,
          color: Colors.white,
        }
      case 'primary-transparent':
        return {
          color: Colors.primary,
          borderWidth: 1,
          borderColor: Colors.primary,
          backgroundColor: Colors.transparent,
        }
      case 'gradient':
        return {
          color: Colors.white,
          borderWidth: 0,
          borderColor: Colors.transparent,
          backgroundColor: Colors.transparent,
        }
      case 'light':
        return {
          color: Colors.darkGrey,
          borderWidth:0,
          borderColor:Colors.transparent,
          backgroundColor: Colors.light,
        }
      case 'light-selected':
        return {
          color: Colors.white,
          borderWidth:0,
          borderColor:Colors.transparent,
          backgroundColor: Colors.vlightGrey,
        }
      default:
        return {
          backgroundColor: Colors.black,
          color: Colors.white,
        }
    }
  }
  
  const getBorderRadius = (rounded) => {
    if (rounded) {
      return styles.container.height / 2
    }
    return 2
  }

  if (!text) {
    text = ' '
  }
  // if(variant === 'gradient'){
  //   return (
  //     <Button
  //       {...rest}
  //       onPress={disabled?null:rest.onPress}
  //       underlayColor={getVariant(variant).backgroundColor}
  //       style={[
  //         {
  //           ...styles.container,
  //           borderRadius: getBorderRadius(rounded),
  //           borderWidth: getVariant(variant).borderWidth,
  //           ...style,
  //         },
  //         disabled && styles.disabled,
  //       ]}
  //     >
  //       <LinearGradient
  //         style={[
  //           {
  //             ...styles.container,
  //             borderRadius: getBorderRadius(rounded),
  //             borderWidth: getVariant(variant).borderWidth,
  //             ...style,
  //           },
  //           disabled && styles.disabled,
  //         ]}
  //         colors={[Colors.highlight, Colors.dark]}
  //       >
  //         {isLoading ? (
  //           <LoadingIcon style={{height:20,width:20,color:Colors.white}}/>
  //         ) : icon ? (
  //           <Icon svg={icon.icon} color={icon.color} size={icon.size} />
  //         ) : (
  //           <Text
  //             style={{
  //               ...styles.text,
  //               color: getVariant(variant).color,
  //             }}
  //           >
  //             {text}
  //           </Text>
  //         )}
  //       </LinearGradient>
  //     </Button>
  //   )
  // }else{
    return (
      <Button
        {...rest}
        onClick={disabled?null:rest.onPress}
        // underlayColor={_.has(style,'backgroundColor')?style.backgroundColor:getVariant(variant).backgroundColor}
        style={
          {
            ...styles.container,
            backgroundColor: getVariant(variant).backgroundColor,
            borderRadius: getBorderRadius(rounded),
            borderWidth: getVariant(variant).borderWidth,
            borderColor: getVariant(variant).borderColor,
            ...style,
          }}
      >
        <div>
          {isLoading ? (
            <LoadingIcon style={{height:20,width:20,color:variant=='primary-transparent'?Colors.primary:Colors.white}}/>
          ) : both ? (
            <div style={styles.both}>
              <Icon svg={icon.icon} color={icon.color} size={icon.size} />
              <Text style = {{color:getVariant(variant).color}}>{text}</Text>
            </div>
          ) : icon ? (<Icon svg={icon.icon} color={icon.color} size={icon.size} />) :
          (
            <Text style = {[styles.text,{color:getVariant(variant).color}]}>{text}</Text>
          )}
        </div>
      </Button>
    )
  // }
  
}

ButtonComponent.defaultProps = {
  rounded: true,
  variant: 'black',
  disabled: false,
  isLoading: false,
  style: {},
}

ButtonComponent.propTypes = {
  variant: PropTypes.oneOf(['white', 'white-outline', 'black', 'primary', 'primary-transparent', 'gradient','light','light-selected','custom']),
  text: PropTypes.string,
  icon: PropTypes.object,
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  style: PropTypes.object,
}

export default ButtonComponent
